module.exports = __webpack_public_path__ + "fonts/fa-solid-900.f54756d.woff2";